import setCustomEventVersions from './setCustomEventVersions/index.js'

// Set source middlewares for Coches.net.
export default [setCustomEventVersions]
